import '.g2{animation:300ms tilt-strong cubic-bezier(0.30,-0.00,0.40,1.30);}.ssr-plugin'
import '.g3{width:360px;}.ssr-plugin'
import '.de{padding:24px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.g4{justify-content:left;}.ssr-plugin'
import '.b2{gap:16px;}.ssr-plugin'
import '.b8{gap:8px;}.ssr-plugin'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import React from 'react'
import { styled, Style } from 'inlines'
import { Text } from '../Text/index.js'
import { shadows } from '../../utils/shadows.js'
import { Overlay } from '../Overlay/index.js'
import { OverlayTrigger } from '../Overlay/OverlayTrigger.js'
import { OverlayContent } from '../Overlay/OverlayContent.js'

type DialogProps = {
  title?: string
  description?: string
  children?: React.ReactNode | (() => React.ReactNode)
  open?: boolean
  onClose?: () => void
  onOpen?: () => void
  style?: Style
}

const Dialog = ({
  title,
  description,
  children,
  open = false,
  onClose,
  onOpen,
  style,
}: DialogProps) => {
  let childrenRef = children as React.ReactNode
  if (typeof children === 'function') {
    childrenRef = children()
  }
  const triggerElement = React.Children.toArray(childrenRef).find(
    (child) => React.isValidElement(child) && child.type === OverlayTrigger,
  )
  const contentElement = React.Children.toArray(childrenRef).filter(
    (child) => !React.isValidElement(child) || child.type === OverlayContent,
  )

  const otherChildren = React.Children.toArray(childrenRef).filter(
    (child) =>
      !React.isValidElement(child) ||
      (child.type !== OverlayTrigger && child.type !== OverlayContent),
  )

  return (
    <Overlay position="center" open={open} onClose={onClose} onOpen={onOpen}>
      <Overlay.Trigger>{triggerElement}</Overlay.Trigger>
      <Overlay.Content
        style={{ boxShadow: shadows.popoverLarge, borderRadius: radius[24] }}
      >
        <styled.div className="g2 g3 de a i g4 b2"
          style={{
            background: `linear-gradient(${colors.neutral10Background}),
              linear-gradient(${colors.neutralInverted100})`,
            borderRadius: radius[24],
            border: `1px solid ${colors.neutral10}`,
            ...style,
          }}
          onClick={(e) => {
            e.stopPropagation()
          }}
        >
          <div className="a i g4 b8"
          >
            {title && (
              <Text variant="subheading-medium" color="neutral100" align="left">
                {title}
              </Text>
            )}
            {description && (
              <Text variant="display-regular" color="neutral60" align="left">
                {description}
              </Text>
            )}
          </div>
          {contentElement}
          {otherChildren}
        </styled.div>
      </Overlay.Content>
    </Overlay>
  )
}

Dialog.Trigger = OverlayTrigger
Dialog.Content = OverlayContent
Dialog.Close = Overlay.Close

// Marker for useOverlay hook to identify overlay components in production builds
Dialog._isOverlayComponent = true

export { Dialog }
